class SignupService {
  constructor ($log, $location, flash, $analytics, Registration, User) {
    this.$log = $log
    this.$analytics = $analytics
    this.$location = $location
    this.flash = flash
    this.Registration = Registration
    this.User = User
  }

  registerBillingInfo(id, token, email, successCallback, failureCallback) {
    var registrationData = {
      email: email,
      token: token.id
    }

    this.Registration.update(
      {id: id},
      registrationData,
      this._onSuccess.bind(
        this, successCallback, registrationData, 'Complete Registration'),
      this._onFail.bind(
        this, failureCallback, registrationData, 'Complete Registration')
    )
  }

  createRegistration(product, user, coverage, successCallback, failureCallback) {
    var registrationData = {
      productCode: product,
      email: user.email,
      userInfo: user,
      addOns: coverage
    }

    this.Registration.create(
      registrationData,
      this._onSuccess.bind(
        this, successCallback, registrationData, 'Create Registration'),
      this._onFail.bind(
        this, failureCallback, registrationData, 'Create Registration')
    )
  }

  _onSuccess(callback, registrationData, name, response) {
    this.$analytics.eventTrack(name + ' Success', registrationData)
    callback(response)
  }

  _onFail(callback, registrationData, name, response) {
    if ( response.status === 409 ) {
      this.flash.setMessage('You already have an account with us.  Please login to access your data.')
      this.$location.url('/login')
      // the account exists
    } else {
      this.$analytics.eventTrack(
        name + ' Error', { error: response.status, data: registrationData})
      this.$log.debug('Failure', response)
      callback(response)
    }
  }

  resend(id, successCallback, failureCallback) {
    this.Registration.resend(
      {id: id},
      (response) => successCallback(response),
      (response) => failureCallback(response)
    )

    this.$analytics.eventTrack('Resent Registration Email', {id: id})
  }

  createAccount(registrationId, password, successCallback, failureCallback) {

    var accountData = {
      registrationId: registrationId,
      password: password
    }

    this.User.create(
      accountData,
      (response) => successCallback(response),
      (response) => failureCallback(response)
    )
  }

}

SignupService.$inject = ['$log', '$location', 'flash', '$analytics', 'Registration', 'User']

export default SignupService
